/* @flow */

import { rem } from 'polished';

import {
  baseFontSize,
  body1FontSize,
  body1FontWeight,
} from '@braindate/ui/lib/token/typography';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  body: {
    // Remove the margin in all browsers
    margin: 0,

    backgroundColor: ({ theme }: ThemeFunction) => theme.colorBase,
    color: ({ theme }: ThemeFunction) => theme.textColor,

    fontFamily: ({ theme }: ThemeFunction) => theme.baseFontFamily,
    fontVariantNumeric: 'lining-nums',
    fontSize: rem(body1FontSize, baseFontSize),
    fontWeight: body1FontWeight,
    lineHeight: 'normal',
    overflowX: 'hidden',
    minHeight: '100vh',
  },
};
